import { render, staticRenderFns } from "./DataTableAcceptTender.vue?vue&type=template&id=3518fe98&"
import script from "./DataTableAcceptTender.vue?vue&type=script&lang=js&"
export * from "./DataTableAcceptTender.vue?vue&type=script&lang=js&"
import style0 from "./DataTableAcceptTender.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports